import React from 'react';
import PropTypes from 'prop-types';

import styles from './AlertZone.css';

const IPropTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  show: PropTypes.bool,
};

const defaultProps = {
  title: null,
  subtitle: '',
  onClick: null,
  show: true,
};

const AlertZone = props => (
  props.show ? (
    <div onClick={props.onClick} className={styles.alert}>
      {props.title && <h4 style={{ margin: 0 }}><b>{props.title}</b></h4>}
      {props.subtitle}
    </div>) : null
);

AlertZone.propTypes = IPropTypes;
AlertZone.defaultProps = defaultProps;

export { AlertZone };



// WEBPACK FOOTER //
// ./src/common/alert-zone/AlertZone.jsx